import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "9",
  height: "9",
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.48828 3.24072V0.240723H3.48828V3.24072H0.488281V5.24072H3.48828V8.24072H5.48828V5.24072H8.48828V3.24072H5.48828Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }